import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import Account from '@/models/v5/account';
import Invitation from '@/models/v5/invitation';
import item_template from '@/../templates/collaborator-item.hbs';

var globalCh = Radio.channel('global');
var CollaboratorItemView = Marionette.View.extend({
    template: Handlebars.compile(item_template),
    tagName: 'tr',
    ui: {
        actionEdit: '.action.edit',
        actionRemove: '.action.remove'
    },
    events: {
        'click @ui.actionEdit': 'editClicked',
        'click @ui.actionRemove': 'removeClicked'
    },
    initialize: function(options) {
        this.targetAccount = this.getOption('targetAccount');
    },
    templateContext: function() {
        var isOwner = (this.model.id === this.targetAccount.id);

        // Find which roles have been granted to this account
        var roles = [];
        
        if (isOwner) {
            // If this is the owner, we only display that role name
            roles.push('Owner');
        } else {
            // Otherwise, build the list of roles from the collection of grants
            this.targetAccount.grants().forEach(function(grant) {
                if (grant.rel.get('grantee').id === this.model.id) {
                    roles.push(grant.rel.get('role').get('name'));
                }
            }, this);
        }

        // Determine what actions should be enabled/disabled
        var primaryAccount = globalCh.request('primary_account');

        var isAdmin = _(roles).contains('Administrator');
        var isMyAccount = (this.model.id === primaryAccount.id);
        var primaryAccountIsOwner = (primaryAccount.id === this.targetAccount.id);

        // Display the earliest date that this account had a grant on the target
        // But if it's an invitation, we display the date that the invitation was sent
        // (And if this is the account owner, we just display nothing)
        if (this.model.type === Invitation.type) {
            this.model.displayDate = this.model.get('created_at');
        } else {
            this.model.displayDate = this.model.get_oldest_grant_date(this.targetAccount);
        }

        var noEdit = isMyAccount || isOwner || this.model.type === Invitation.type;
        var noRemove = isMyAccount || isOwner || (isAdmin && !primaryAccountIsOwner);

        return {
            inactive: !!this.model.get('state'),
            status: this.model.get('state') || Account.defaultState,
            createdAt: this.model.displayDate,
            roles: _.sortBy(roles, function(name) { return name; }),
            isOwner: isOwner,
            isMyAccount: isMyAccount,
            noEdit: noEdit,
            noRemove: noRemove
        };
    },
    // Need this to allow lazy loading of usernames for collaborators missing info
    modelEvents: {
        'change': 'render'
    },
    onRender: function() {
        if (!this.model.get('name')){
            this.model.fetch();
        }
        this.ui.actionEdit.tooltip({
            delay: { show: 500, hide: 100 }
        });
        this.ui.actionRemove.tooltip({
            delay: { show: 500, hide: 100 }
        });
    },
    editClicked: function() {
        var active = globalCh.request('active_account');
        globalCh.request('show_collaborators_profile', active, this.model);
    },
    removeClicked: function() {
        if (this.model.type === Invitation.type) {
            if (this.model.get('state') === Invitation.state.expired) {
                return this.model.destroy();
            } else {
                return globalCh.request('showCancelInvitationDialog', this.model);
            }
        }

        globalCh.request('showRemoveCollaboratorDialog', this.targetAccount, this.model);
    }
});

export default CollaboratorItemView;
